// src/components/Chat/ChatBot.tsx
// Komponen chatbot - render chat window via Portal + flyTo navigation

import React from "react";
import ReactDOM from "react-dom";
import { NoiseCluster } from "../../types/mapTypes";
import { FlyToTarget } from "../../types/chatTypes";
import { useChat } from "../../hooks/useChat";
import ChatWindow from "./ChatWindow";

interface ChatBotProps {
  clusters: NoiseCluster[];
  isOpen: boolean;
  onToggle: () => void;
  onFlyTo?: (target: FlyToTarget) => void;
}

const ChatBot: React.FC<ChatBotProps> = ({ clusters, isOpen, onToggle, onFlyTo }) => {
  const {
    messages,
    isLoading,
    sendMessage,
    clearChat,
    noiseSummary,
  } = useChat(clusters, { onFlyTo });

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <ChatWindow
      messages={messages}
      isLoading={isLoading}
      noiseSummary={noiseSummary}
      onSend={sendMessage}
      onClose={onToggle}
      onClear={clearChat}
    />,
    document.body
  );
};

export default ChatBot;
